import * as _actions from './actions';
import _reducer from './reducer';
import _GroupPerformance from './model';

export const actions = _actions;
export const reducer = _reducer;
export const GroupPerformance = _GroupPerformance;



// WEBPACK FOOTER //
// ./data/GroupPerformance/index.js